<template>
  <div style="height: 100%;">
    <manageHeaderNavigation></manageHeaderNavigation>
    <div class="container" style="height:100%;">
      <el-row type="flex" justify="left" style="height: 100%;">
        <el-col class="leftMenu">
          <manageVerticalNavigation></manageVerticalNavigation>
          </el-col>
        <el-col class="rightContent">
          <router-view></router-view>
          </el-col>
      </el-row>
    </div>
  </div>
</template>
<script type="text/javascript">
import manageHeaderNavigation from '@c/navigation/manageHeaderNavigation.vue'
import manageVerticalNavigation from '@c/navigation/manageVerticalNavigation.vue'
export default {
  name: 'manageFrame',
  components: {
    manageHeaderNavigation,
    manageVerticalNavigation
  }
}
</script>
<style type="text/css" scoped>
.leftMenu {
  width: 80px;
  height: 100%;
  flex: none;
  overflow-y: auto;
  background-color: #333333;
}
.leftMenu::-webkit-scrollbar {
  display: none;
}
.rightContent {
  overflow-y: auto;
  height: 100%;
  /* width: 100%; */
  flex: 1;
}

</style>
